module.exports = __webpack_public_path__ + "img/jellybean_camaro.65215a62.png";